/** @format */

import React, { useEffect, useRef, useState } from "react";
import bmiImage from "../../images/enquiry/bmi.svg";
import { BASE_URL } from "../../data/BaseUrl";
import { chatBotBmi } from "../../data/ApiEndpoints";
import { toast } from "react-toastify";

const BmiBmr = ({ userDetails, next }) => {
  const [activeGender, setActiveGender] = useState();
  const [formData, setFormData] = useState({});
  const [isBmi, setIsBmi] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  const [result, setResult] = useState("");
  const resultRef = useRef();

  useEffect(() => {
    resultRef.current = result;
  }, [result]);

  const isValidFormData = () => {
    const { feets, inches, weight, age } = formData;

    // Validate required fields
    if (!feets || !inches || !weight || !age || !activeGender) {
      toast.error("All fields are required");
      return false;
    }

    if (isNaN(feets) || isNaN(inches) || isNaN(weight) || isNaN(age)) {
      toast.error("Invalid numeric data");
      return false;
    }

    if (feets < 1 || feets > 10 || inches < 0 || inches > 11) {
      toast.error("Feet and inches must be within valid range");
      return false;
    }

    if (age < 18) {
      toast.error("Minimum age required is 18..!");
      return false;
    }

    if (weight < 10) {
      toast.error("Invalid weight!");
      return false;
    }

    return true;
  };

  function fetchBmiData() {
    try {
      if (!isValidFormData()) return;

      let URL = `${BASE_URL}${chatBotBmi}`;

      URL += `?height=${formData?.feets}'${formData?.inches}&weight=${formData?.weight}&age=${formData?.age}&gender=${activeGender}&user_id=${userDetails?.uid}`;

      setIsOpened(true);
      const source = new EventSource(URL);

      source.addEventListener("message", (e) => {
        const data = e.data;

        if (data !== "\n") {
          resultRef.current = resultRef.current + data;
          console.log("ResultRef.current: " + resultRef.current);
          setResult(resultRef.current);
        }
      });

      source.addEventListener("error", (e) => {
        console.error("Error: ", e);
        setIsOpened(false);
        setIsBmi(true);
        source.close();
      });

      return () => {
        source.close();
      };
    } catch (error) {
      console.log(error);
    }
  }

  const calculateBMI = () => {
    const heightInMeters =
      parseInt(formData?.feets) * 0.3048 + parseInt(formData?.inches) * 0.0254;
    const bmi = parseInt(formData?.weight) / (heightInMeters * heightInMeters);
    return parseFloat(bmi.toFixed(1));
  };

  const getBMICategory = (activeCategory) => {
    const bmi = calculateBMI();
    let category = "";
    let className = "";
    let isActive = false;

    if (bmi < 16) {
      category = "Severe Thinness";
      className = "red";
    } else if (bmi >= 16 && bmi < 17) {
      category = "Moderate Thinness";
      className = "yellow";
    } else if (bmi >= 17 && bmi < 18.5) {
      category = "Mild Thinness";
      className = "yellow";
    } else if (bmi >= 18.5 && bmi <= 25) {
      category = "Normal BMI";
      className = "green";
    } else if (bmi > 25 && bmi <= 30) {
      category = "Overweight";
      className = "red";
    } else if (bmi > 30 && bmi <= 40) {
      category = "Obese Class I";
      className = "red";
    } else {
      category = "Obese Class II";
      className = "red";
    }

    if (activeCategory && category === activeCategory) {
      isActive = true;
    }

    return { name: category, className: className, isActive: isActive };
  };

  const allBMICategories = [
    { name: "Severe Thinness", range: "< 16" },
    { name: "Moderate Thinness", range: "16 - 17" },
    { name: "Mild Thinness", range: "17 - 18.5" },
    { name: "Normal BMI", range: "18.5 - 25" },
    { name: "Overweight", range: "25 - 30" },
    { name: "Obese Class I", range: "30 - 40" },
    { name: "Obese Class II", range: "> 40" },
  ];

  return (
    <div className="flex-k flex-col-k js-center-k items-center-k">
      {(isOpened || isBmi) && (
        <div className="grid-k w-full-k grid-col-2-k js-start-k p-2">
          {isBmi ? (
            <div className="bmi-details-box grid-span-2-k gap-4 my-4 grid-k grid-col-3-k">
              <div className="bmi-left-box">
                <h1>Your Result</h1>
                <h1>{calculateBMI()}</h1>
                <div
                  className={`category js-center-k ${
                    getBMICategory()?.className
                  }`}
                >
                  {getBMICategory().name}
                </div>
              </div>
              <div className="grid-span-2-k">
                <div>
                  <h4>BMI TABLE FOR ADULTS</h4>
                  <p>
                    This is the World Health Organisation's (WHO) recommended
                    body weight based on BMI values for adults. It is used for
                    both men and women, age 18 or older
                  </p>
                </div>
                <div className="grid-k grid-col-2-k gap-1-k">
                  {allBMICategories.map((category) => {
                    return (
                      <div
                        key={category?.name}
                        className={`category js-between-k ${
                          getBMICategory(category?.name)?.isActive
                            ? getBMICategory(category?.name).className
                            : ""
                        }`}
                      >
                        <span>{category.name}</span>
                        <span>{category.range}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : null}
          <p
            className="grid-span-2-k"
            dangerouslySetInnerHTML={{
              __html: resultRef.current ? resultRef.current : "",
            }}
          ></p>
          {isBmi && (
            <div className="flex-k grid-span-2-k my-3 js-end-k gap-1-k">
              <button
                onClick={() => {
                  try {
                    resultRef.current = null;
                    setIsOpened(false);
                    setIsBmi(false);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                className="btn-k btn-secondary-k"
              >
                Reset
              </button>
              <button onClick={next} className="btn-k btn-primary-k">
                Continue
              </button>
            </div>
          )}
        </div>
      )}

      {!isOpened && !isBmi && (
        <div className="grid-k gap-2-k grid-col-2-k">
          <div className="grid-k js-center-k p-4">
            <img src={bmiImage} alt="BMI_Image" />
          </div>
          <div className="bmi-box">
            <div>
              <label className="my-2">Select your Gender*</label>
              <div className="grid-k grid-col-3-k gap-1-k">
                <span
                  onClick={() => setActiveGender("male")}
                  className={`${
                    activeGender === "male" ? "dark-bg-k" : ""
                  } flex-k js-center-k items-center-k p-1-k cursor-pointer-k select-none-k border rounded-2`}
                >
                  Male
                </span>
                <span
                  onClick={() => setActiveGender("female")}
                  className={`${
                    activeGender === "female" ? "dark-bg-k" : ""
                  } flex-k js-center-k items-center-k p-1-k cursor-pointer-k select-none-k border rounded-2`}
                >
                  Female
                </span>
                <span
                  onClick={() => setActiveGender("other")}
                  className={`${
                    activeGender === "other" ? "dark-bg-k" : ""
                  } flex-k js-center-k items-center-k p-1-k cursor-pointer-k select-none-k border rounded-2`}
                >
                  Others
                </span>
              </div>
            </div>
            <div>
              <div className="grid-k my-3 py-3 gap-1-k grid-col-2-k">
                <div>
                  <label>What's your Height?</label>
                  <div className="grid-k grid-col-2-k gap-1-k">
                    <input
                      type="text"
                      className="input-k"
                      placeholder="Enter Feets"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          feets: e.target.value,
                        })
                      }
                      value={formData?.feets}
                    />
                    <input
                      type="text"
                      className="input-k"
                      placeholder="Enter Inches"
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          inches: e.target.value,
                        })
                      }
                      value={formData?.inches}
                    />
                  </div>
                </div>
                <div className="flex-k flex-col-k">
                  <label>What's your Age?</label>
                  <input
                    type="text"
                    className="input-k"
                    placeholder="Enter your Age (Yrs)"
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        age: e.target.value,
                      })
                    }
                    value={formData?.age}
                  />
                </div>
                <div className="grid-span-2-k">
                  <label>What's your Weight?</label>
                  <input
                    type="text"
                    className="input-k"
                    placeholder="Enter your Weight (Kgs)"
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        weight: e.target.value,
                      })
                    }
                    value={formData?.weight}
                  />
                </div>
                <div className="grid-span-2-k my-5 grid-k">
                  <button
                    onClick={() => fetchBmiData()}
                    className="btn-k btn-primary-k"
                  >
                    Calculate BMI
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BmiBmr;
